export const MIME_TYPES = {
    image: [
        'image/png',
        'image/jpeg',
        'image/pjpeg',
        'image/tiff',
        'image/x-tiff',
        'image/webp',
        'image/svg+xml',
        'image/x-icon',
        'image/gif',
        'image/jpg',
    ],
    documents: {
        pdf: ['application/pdf'],
        doc: [
            'application/doc',
            'application/ms-doc',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ],
        excel: [
            'application/excel',
            'application/vnd.ms-excel',
            'application/x-excel',
            'application/x-msexcel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ],
        ppt: [
            'application/mspowerpoint',
            'application/powerpoint',
            'application/vnd.ms-powerpoint',
            'application/x-mspowerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        ],
        text: ['application/rtf', 'text/plain'],
        csv: ['text/csv'],
    },
    video: [
        'application/x-troff-msvideo',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/quicktime',
        'video/x-quicktime',
        'image/mov',
        'video/avi',
        'video/mp4',
        'application/mp4',
        'video/ogg',
        'video/x-ms-wmv',
        'video/x-ms-asf',
        'video/webm',
    ],
    audio: [
        'audio/aiff',
        'audio/x-midi',
        'audio/x-wav',
        'audio/ogg',
        'audio/webm',
        'audio/mpeg',
    ],
    zip: [
        'application/zip',
        'application/x-zip',
        'application/x-zip-compressed',
        'application/x-compress',
        'application/x-compressed',
        'multipart/x-zip',
    ],
};
